class ShopTheLookDrawer extends HTMLElement {
  connectedCallback() {
    this.overlay = this.querySelector('[data-shop-the-look-overlay]');
    this.panel = this.querySelector('[data-shop-the-look-panel]');
    this.openButton = this.querySelector('[data-shop-the-look-open]');
    this.buttonLabel = this.querySelector('[data-shop-the-look-label]');
    this._boundToggle = this.toggle.bind(this);
    this.openButton?.addEventListener('click', this._boundToggle);
    this._onEscape = (event) => {
      if (event.key !== 'Escape' || event.defaultPrevented || event.target.closest('dialog, [popover], details[open]')) return;
      if (!this.isOpen) return;
      event.preventDefault();
      this.close();
    };
    this.addEventListener('keydown', this._onEscape);
  }

  disconnectedCallback() {
    this.openButton?.removeEventListener('click', this._boundToggle);
    this.removeEventListener('keydown', this._onEscape);
    this.clearCloseAnimation();
  }

  get slide() {
    return this.closest('[data-shop-the-look-slide]');
  }

  get isOpen() {
    return this.overlay && !this.overlay.classList.contains('shop-the-look-overlay--hidden');
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    if (!this.panel || this.isOpen) return;

    this.clearCloseAnimation();
    this.panel.hidden = false;
    this.panel.inert = false;
    this.panel.removeAttribute('aria-hidden');
    // Lay out the collapsed panel before starting its entrance transition.
    this.overlay.offsetHeight;
    this.overlay.classList.remove('shop-the-look-overlay--hidden');
    this.slide?.classList.add('is-drawer-open');
    this.openButton?.setAttribute('aria-expanded', 'true');
    if (this.buttonLabel) this.buttonLabel.textContent = this.buttonLabel.dataset.closeLabel;
  }

  close() {
    if (!this.panel || !this.isOpen) return;

    this.openButton?.focus();
    this.panel.inert = true;
    this.panel.setAttribute('aria-hidden', 'true');
    this.overlay.classList.add('shop-the-look-overlay--hidden');
    this.slide?.classList.remove('is-drawer-open');
    this.openButton?.setAttribute('aria-expanded', 'false');
    if (this.buttonLabel) this.buttonLabel.textContent = this.buttonLabel.dataset.openLabel;

    this._finishClose = (event) => {
      if (event && (event.target !== this.overlay || event.propertyName !== 'transform')) return;
      this.clearCloseAnimation();
      if (!this.isOpen) this.panel.hidden = true;
    };
    this.overlay.addEventListener('transitionend', this._finishClose);
    this._closeTimer = setTimeout(this._finishClose, 400);
  }

  clearCloseAnimation() {
    clearTimeout(this._closeTimer);
    this.overlay?.removeEventListener('transitionend', this._finishClose);
  }
}

customElements.define('shop-the-look-drawer', ShopTheLookDrawer);
